/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Address,
  Contract,
  ContractState,
  TestContractResult,
  HexString,
  ContractFactory,
  EventSubscribeOptions,
  EventSubscription,
  CallContractParams,
  CallContractResult,
  TestContractParams,
  ContractEvent,
  subscribeContractEvent,
  subscribeContractEvents,
  testMethod,
  callMethod,
  multicallMethods,
  fetchContractState,
  Asset,
  ContractInstance,
  getContractEventsCurrentCount,
  TestContractParamsWithoutMaps,
  TestContractResultWithoutMaps,
  SignExecuteContractMethodParams,
  SignExecuteScriptTxResult,
  signExecuteMethod,
  addStdIdToFields,
  encodeContractFields,
  Narrow,
} from "@alephium/web3";
import { default as AlphUnstakeVaultContractJson } from "../AlphUnstakeVault.ral.json";
import { getContractByCodeHash, registerContract } from "./contracts";
import * as types from "./types";

// Custom types for the contract
export namespace AlphUnstakeVaultTypes {
  export type Fields = {
    xalphToken: HexString;
    unstakerAddress: Address;
    totalUnstakeAmount: bigint;
    unstakeStartTime: bigint;
    unstakeDuration: bigint;
    withdrawnAmount: bigint;
  };

  export type State = ContractState<Fields>;

  export interface CallMethodTable {
    mulDiv: {
      params: CallContractParams<{ a: bigint; b: bigint; denominator: bigint }>;
      result: CallContractResult<bigint>;
    };
    getTotalUnstakeAmount: {
      params: Omit<CallContractParams<{}>, "args">;
      result: CallContractResult<bigint>;
    };
    getClaimableAmount: {
      params: Omit<CallContractParams<{}>, "args">;
      result: CallContractResult<bigint>;
    };
    claim: {
      params: CallContractParams<{ amount: bigint }>;
      result: CallContractResult<boolean>;
    };
    destroy: {
      params: Omit<CallContractParams<{}>, "args">;
      result: CallContractResult<null>;
    };
  }
  export type CallMethodParams<T extends keyof CallMethodTable> =
    CallMethodTable[T]["params"];
  export type CallMethodResult<T extends keyof CallMethodTable> =
    CallMethodTable[T]["result"];
  export type MultiCallParams = Partial<{
    [Name in keyof CallMethodTable]: CallMethodTable[Name]["params"];
  }>;
  export type MultiCallResults<T extends MultiCallParams> = {
    [MaybeName in keyof T]: MaybeName extends keyof CallMethodTable
      ? CallMethodTable[MaybeName]["result"]
      : undefined;
  };
  export type MulticallReturnType<Callss extends MultiCallParams[]> = {
    [index in keyof Callss]: MultiCallResults<Callss[index]>;
  };

  export interface SignExecuteMethodTable {
    mulDiv: {
      params: SignExecuteContractMethodParams<{
        a: bigint;
        b: bigint;
        denominator: bigint;
      }>;
      result: SignExecuteScriptTxResult;
    };
    getTotalUnstakeAmount: {
      params: Omit<SignExecuteContractMethodParams<{}>, "args">;
      result: SignExecuteScriptTxResult;
    };
    getClaimableAmount: {
      params: Omit<SignExecuteContractMethodParams<{}>, "args">;
      result: SignExecuteScriptTxResult;
    };
    claim: {
      params: SignExecuteContractMethodParams<{ amount: bigint }>;
      result: SignExecuteScriptTxResult;
    };
    destroy: {
      params: Omit<SignExecuteContractMethodParams<{}>, "args">;
      result: SignExecuteScriptTxResult;
    };
  }
  export type SignExecuteMethodParams<T extends keyof SignExecuteMethodTable> =
    SignExecuteMethodTable[T]["params"];
  export type SignExecuteMethodResult<T extends keyof SignExecuteMethodTable> =
    SignExecuteMethodTable[T]["result"];
}

class Factory extends ContractFactory<
  AlphUnstakeVaultInstance,
  AlphUnstakeVaultTypes.Fields
> {
  encodeFields(fields: AlphUnstakeVaultTypes.Fields) {
    return encodeContractFields(
      addStdIdToFields(this.contract, fields),
      this.contract.fieldsSig,
      types.AllStructs
    );
  }

  consts = {
    FullMathError: { DivByZero: BigInt("350"), MulDivOverflow: BigInt("351") },
    ErrorCodes: {
      InvalidCaller: BigInt("20"),
      InsufficientClaimableAmount: BigInt("21"),
      InvalidUnstakeDuration: BigInt("22"),
      InvalidTimestamp: BigInt("23"),
    },
  };

  at(address: string): AlphUnstakeVaultInstance {
    return new AlphUnstakeVaultInstance(address);
  }

  tests = {
    mulDiv: async (
      params: TestContractParamsWithoutMaps<
        AlphUnstakeVaultTypes.Fields,
        { a: bigint; b: bigint; denominator: bigint }
      >
    ): Promise<TestContractResultWithoutMaps<bigint>> => {
      return testMethod(this, "mulDiv", params, getContractByCodeHash);
    },
    getTotalUnstakeAmount: async (
      params: Omit<
        TestContractParamsWithoutMaps<AlphUnstakeVaultTypes.Fields, never>,
        "args"
      >
    ): Promise<TestContractResultWithoutMaps<bigint>> => {
      return testMethod(
        this,
        "getTotalUnstakeAmount",
        params,
        getContractByCodeHash
      );
    },
    getClaimableAmount: async (
      params: Omit<
        TestContractParamsWithoutMaps<AlphUnstakeVaultTypes.Fields, never>,
        "args"
      >
    ): Promise<TestContractResultWithoutMaps<bigint>> => {
      return testMethod(
        this,
        "getClaimableAmount",
        params,
        getContractByCodeHash
      );
    },
    claim: async (
      params: TestContractParamsWithoutMaps<
        AlphUnstakeVaultTypes.Fields,
        { amount: bigint }
      >
    ): Promise<TestContractResultWithoutMaps<boolean>> => {
      return testMethod(this, "claim", params, getContractByCodeHash);
    },
    destroy: async (
      params: Omit<
        TestContractParamsWithoutMaps<AlphUnstakeVaultTypes.Fields, never>,
        "args"
      >
    ): Promise<TestContractResultWithoutMaps<null>> => {
      return testMethod(this, "destroy", params, getContractByCodeHash);
    },
  };

  stateForTest(
    initFields: AlphUnstakeVaultTypes.Fields,
    asset?: Asset,
    address?: string
  ) {
    return this.stateForTest_(initFields, asset, address, undefined);
  }
}

// Use this object to test and deploy the contract
export const AlphUnstakeVault = new Factory(
  Contract.fromJson(
    AlphUnstakeVaultContractJson,
    "",
    "5216c458f360d0f51f5e2109a760814ff97eab76f546adc835eb318c6cbc5256",
    types.AllStructs
  )
);
registerContract(AlphUnstakeVault);

// Use this class to interact with the blockchain
export class AlphUnstakeVaultInstance extends ContractInstance {
  constructor(address: Address) {
    super(address);
  }

  async fetchState(): Promise<AlphUnstakeVaultTypes.State> {
    return fetchContractState(AlphUnstakeVault, this);
  }

  view = {
    mulDiv: async (
      params: AlphUnstakeVaultTypes.CallMethodParams<"mulDiv">
    ): Promise<AlphUnstakeVaultTypes.CallMethodResult<"mulDiv">> => {
      return callMethod(
        AlphUnstakeVault,
        this,
        "mulDiv",
        params,
        getContractByCodeHash
      );
    },
    getTotalUnstakeAmount: async (
      params?: AlphUnstakeVaultTypes.CallMethodParams<"getTotalUnstakeAmount">
    ): Promise<
      AlphUnstakeVaultTypes.CallMethodResult<"getTotalUnstakeAmount">
    > => {
      return callMethod(
        AlphUnstakeVault,
        this,
        "getTotalUnstakeAmount",
        params === undefined ? {} : params,
        getContractByCodeHash
      );
    },
    getClaimableAmount: async (
      params?: AlphUnstakeVaultTypes.CallMethodParams<"getClaimableAmount">
    ): Promise<
      AlphUnstakeVaultTypes.CallMethodResult<"getClaimableAmount">
    > => {
      return callMethod(
        AlphUnstakeVault,
        this,
        "getClaimableAmount",
        params === undefined ? {} : params,
        getContractByCodeHash
      );
    },
    claim: async (
      params: AlphUnstakeVaultTypes.CallMethodParams<"claim">
    ): Promise<AlphUnstakeVaultTypes.CallMethodResult<"claim">> => {
      return callMethod(
        AlphUnstakeVault,
        this,
        "claim",
        params,
        getContractByCodeHash
      );
    },
    destroy: async (
      params?: AlphUnstakeVaultTypes.CallMethodParams<"destroy">
    ): Promise<AlphUnstakeVaultTypes.CallMethodResult<"destroy">> => {
      return callMethod(
        AlphUnstakeVault,
        this,
        "destroy",
        params === undefined ? {} : params,
        getContractByCodeHash
      );
    },
  };

  transact = {
    mulDiv: async (
      params: AlphUnstakeVaultTypes.SignExecuteMethodParams<"mulDiv">
    ): Promise<AlphUnstakeVaultTypes.SignExecuteMethodResult<"mulDiv">> => {
      return signExecuteMethod(AlphUnstakeVault, this, "mulDiv", params);
    },
    getTotalUnstakeAmount: async (
      params: AlphUnstakeVaultTypes.SignExecuteMethodParams<"getTotalUnstakeAmount">
    ): Promise<
      AlphUnstakeVaultTypes.SignExecuteMethodResult<"getTotalUnstakeAmount">
    > => {
      return signExecuteMethod(
        AlphUnstakeVault,
        this,
        "getTotalUnstakeAmount",
        params
      );
    },
    getClaimableAmount: async (
      params: AlphUnstakeVaultTypes.SignExecuteMethodParams<"getClaimableAmount">
    ): Promise<
      AlphUnstakeVaultTypes.SignExecuteMethodResult<"getClaimableAmount">
    > => {
      return signExecuteMethod(
        AlphUnstakeVault,
        this,
        "getClaimableAmount",
        params
      );
    },
    claim: async (
      params: AlphUnstakeVaultTypes.SignExecuteMethodParams<"claim">
    ): Promise<AlphUnstakeVaultTypes.SignExecuteMethodResult<"claim">> => {
      return signExecuteMethod(AlphUnstakeVault, this, "claim", params);
    },
    destroy: async (
      params: AlphUnstakeVaultTypes.SignExecuteMethodParams<"destroy">
    ): Promise<AlphUnstakeVaultTypes.SignExecuteMethodResult<"destroy">> => {
      return signExecuteMethod(AlphUnstakeVault, this, "destroy", params);
    },
  };

  async multicall<Calls extends AlphUnstakeVaultTypes.MultiCallParams>(
    calls: Calls
  ): Promise<AlphUnstakeVaultTypes.MultiCallResults<Calls>>;
  async multicall<Callss extends AlphUnstakeVaultTypes.MultiCallParams[]>(
    callss: Narrow<Callss>
  ): Promise<AlphUnstakeVaultTypes.MulticallReturnType<Callss>>;
  async multicall<
    Callss extends
      | AlphUnstakeVaultTypes.MultiCallParams
      | AlphUnstakeVaultTypes.MultiCallParams[]
  >(callss: Callss): Promise<unknown> {
    return await multicallMethods(
      AlphUnstakeVault,
      this,
      callss,
      getContractByCodeHash
    );
  }
}
